class LazyBackgroundLoader {
  constructor(element) {
    this.element = element;
    this.init();
  }

  init() {
    if ("IntersectionObserver" in window) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadBackgroundImage(entry.target);
            this.observer.unobserve(entry.target);
          }
        });
      });

      this.observer.observe(this.element);
    } else {
      // Fallback for browsers that do not support IntersectionObserver
      this.loadBackgroundImage(this.element);
    }
  }

  loadBackgroundImage(element) {
    const imageUrl = element.getAttribute("data-bg-url");
    if (imageUrl) {
      element.style.backgroundImage = `url('${imageUrl}')`;
    }
  }
}

document.querySelectorAll('[data-bg-url]').forEach(element => {
	new LazyBackgroundLoader(element);
});